import React from 'react';
import { Header, Segment, Tab, Loader, Button, Icon } from 'semantic-ui-react';
import axios from 'axios/index';
import { Link } from 'react-router-dom';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive/index';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import StaffPollReport from './StaffPollReport';
import SspPollReport from './SspPollReport';
import moment from 'moment';

export default class PollReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            activeIndex: (localStorage.getItem('activeIndex') && localStorage.getItem('activeIndex') !== 'null') ? localStorage.getItem('activeIndex') : 0,
            pollList: []
        };

        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        axios.get('questionnaire/all/3/')
            .then(res => {
                const pollList = res.data;
                this.setState({ pollList, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch polls.');
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('activeIndex', activeIndex);
    }

    render() {
        const panes = [
            {
                menuItem: 'Evaluacija nastavnog osoblja',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <StaffPollReport
                            pollList={this.state.pollList.filter(el => el.questionnaireType._key === 'academic staff evaluation')}
                        />
                    </Tab.Pane>
                )
            },
            {
                menuItem: 'Evaluacija studijskih programa',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <SspPollReport
                            pollList={this.state.pollList.filter(el => el.questionnaireType._key === 'study program evaluation')}
                        />
                    </Tab.Pane>
                )
            }
        ];

        return (
            <div>
                <Header as="h1"> Izvještaji </Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3" >
                            Pregled anketa
                        </Header>
                    </Segment>

                    <Segment>
                        <Tab
                            id="myTab"
                            menu={{ secondary: true, pointing: true, color: 'blue' }}
                            panes={panes}
                            activeIndex={this.state.activeIndex}
                            onTabChange={this.handleTabChange}
                        />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/Reports/PollReport.js